// src/CardList.js
import React from "react";
import Card from "./Card";
import "./Card.css";
import avatar from "../images/avatar.jpeg";

const CardList = () => {
  const testimonials = [
    {
      testimonial:
        "Studying under Chetan Sir has transformed my approach to mathematics. His ability to break down complex concepts into simple, understandable parts has made me more confident in tackling my exams. Every session with him is a blend of knowledge and inspiration.",
      author: "Rohan Kumar",
      avatar: avatar,
    },
    {
      testimonial:
        "Chetan Sir's teaching has been a game-changer for me. His passion for mathematics shines through every lesson, making even the toughest topics approachable. I've grown not just in my mathematical skills, but also in my overall confidence.",
      author: "Shadab Lucky",
      avatar: avatar,
    },
    {
      testimonial:
        "What sets Chetan Sir apart is his innovative teaching style. His deep knowledge of trigonometry and differential equations, coupled with personalized attention, has made these subjects much clearer to me. He truly inspires a love for learning.",
      author: "Vaibhav Singh",
      avatar: avatar,
    },
    {
      testimonial:
        "The structured approach that Chetan Sir brings to problem-solving is unparalleled. His comprehensive coverage of the syllabus has been key to my success in mathematics. I'm incredibly thankful for his dedication and support.",
      author: "Priya Vats",
      avatar: avatar,
    },
    {
      testimonial:
        "Under Chetan Sir's guidance, my perspective on mathematics has changed completely. His insightful explanations and engaging teaching methods make every class a valuable experience. I feel more prepared and confident than ever before.",
      author: "Gulshan Kumar",
      avatar: avatar,
    },
    {
      testimonial:
        "Chetan Sir has redefined my learning experience. His clear, concise explanations and unwavering dedication to his students have made mathematics not only manageable but also enjoyable. I would highly recommend him to anyone serious about excelling in math.",
      author: "Adarsh Jha",
      avatar: avatar,
    },
    {
      testimonial:
        "Learning mathematics with Chetan Sir has been a journey of growth. His detailed explanations and practical examples have deepened my understanding of probability, vectors, and beyond. His teaching has instilled in me a sense of curiosity and critical thinking.",
      author: "Sakshi Jha",
      avatar: avatar,
    },
  ];

  return (
    <section className="card-list">
      {testimonials.map((testimonial, index) => (
        <Card
          key={index}
          testimonial={testimonial.testimonial}
          author={testimonial.author}
          avatar={testimonial.avatar}
        />
      ))}
    </section>
  );
};

export default CardList;
